<template>
    <div>
      <arksnackbar v-model="status" ></arksnackbar>
      <v-autocomplete
        hide-details
        append-icon="search"
        clearable
        :label="label"
        :loading="status.loading"
        :items="items"
        item-text="isimAra"
        item-value="id"
        :search-input.sync="search"
        v-model="Model"
        return-object
        :required="required"
        :rules="rules"
        :readonly="false"
        :disabled="aktifmi"
        :autofocus="autofocuss"
      >
      </v-autocomplete>
    </div>
</template>

<script>
import tool from "../tools";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";

export default {
  props: ["value", "apiname", "label", "tip", "required", "rules","autofocuss","aktifmi", "icdis"],
  components: {
    arksnackbar
  },
  computed: {
    Model: {
      get: function() {
        var r = { id: "", isim: "", kod: "", isimAra: "",YurtIci_YurtDisi:"",CariKod:"",KDV:0 };
        if (
          this.value != undefined &&
          this.value != null &&
          this.value.id != null
        ) {
          r = {
            id: this.value.id,
            KDV:this.value.KDV,
            isim: this.value.isim,
            kod: this.value.kod,
            YurtIci_YurtDisi:this.value.YurtIci_YurtDisi,
            isimAra: this.IsimAra(this.value),
            CariKod:this.value.CariKod
          };
        }
        this.SetItems(r);
        return r;
      },
      set: function(newValue) {

        if (newValue == null) {
          newValue = { id: "", isim: "", kod: "", isimAra: "",YurtIci_YurtDisi:"",CariKod:"",KDV:0 };
        }
        this.$emit("input", newValue);
      }
    }
  },

  data() {
    return {
      loading: false,
      items: [],
      search: null,
      status: tool.NewSatatus(),
      ayrac: "  -  "
    };
  },

  watch: {
    search(val) {
      if (val != undefined && val == "") {
        this.items = [{ id: "", isim: "", kod: "", isimAra: "",YurtIci_YurtDisi:"",CariKod:"",KDV:0 }];
        this.Model = { id: "", isim: "", kod: "", isimAra: "",YurtIci_YurtDisi:"",CariKod:"",KDV:0 };
      } else {
        val &&
          val.indexOf(this.ayrac) == -1 &&
          val.length > 1 &&
          this.querySelections(val);
      }
    }
  },
  methods: {
    querySelections(v) {


      let YurtIcDis = 0
      if(this.icdis==false)
      {
        YurtIcDis=1;
      }
      if(this.icdis==true)
      {
        YurtIcDis=2;
      }
      
      console.log(this.tip);
      var prm = {
        id: "",
        kod: "",
        aciklama: v,
        tip: this.tip,
        YurtIcDis:YurtIcDis,
      };
      setTimeout(() => {
        this.Ara(prm);
      }, 400);
    },

    IsimAra(v) {
        var text = null
        if (v.isim != null) {
          text = v.isim.replace(this.ayrac, "-")
        }
        text=text+this.ayrac
        if (v.kod != null) {
          text = text + v.kod.replace(this.ayrac, "-")
        }
      return (text);
    },
    SetItems(v) {

      var vid=String(v.id)

      if (v.id != null && vid.length>0  ) {
        this.items = [v];
      } else {
        this.items = [];
      }
    },

    Ara(prm) {
      
      this.status.loading = true;
      tool.http_post(this, this.apiname, prm).then(
        response => {
          this.items = [];
          for (var i = 0; i < response.body.length; i++) {
            this.items.push({
              id: response.body[i].id,
              isim: response.body[i].isim,
              KDV:response.body[i].KDV,
              kod: response.body[i].kod,
              CariKod:response.body[i].CariKod,
              YurtIci_YurtDisi:response.body[i].YurtIci_YurtDisi,
              isimAra: this.IsimAra(response.body[i])
            });
          }

          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );
    }
  }
};
</script>